import './FilingPacks.css';

import { useState } from "react";
import { Modal, Snack, Snackbar, Spinner, Text, Tooltip, Button } from "@nike/eds";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CopyPaste } from "@nike/nike-design-system-icons";
import { FilingPacksTable } from "../components/filing_packs_table/FilingPacksTable";
import { useFilingPacksTable } from "./useFilingPacksTable";

export function FilingPacks() {
    const { downloadError, dismissDownloadError, payloadContent, payloadLoading, dismissPayloadContent, ...tableProps } = useFilingPacksTable();
    const [copied, setCopied] = useState(false);

    return (
        <div className="filing-packs-page">
            <Snackbar>
                {downloadError && (
                    <Snack id="download-error" status="error" onDismiss={dismissDownloadError} autoDismissDuration={15000}>
                        <p className="eds-type--body-2">{downloadError}</p>
                    </Snack>
                )}
            </Snackbar>
            <FilingPacksTable
                {...tableProps}
                tableTitle={<Text font="title-2" as="h2">Filing Packs</Text>}
            />
            <Modal
                isOpen={payloadLoading || payloadContent !== null}
                onDismiss={dismissPayloadContent}
                headerSlot="Payload"
                footerSlot={
                    <div className="eds-flex eds-gap--16 modal-footer-actions">
                        <Tooltip bodySlot={copied ? "Copied!" : "Copy to clipboard"}>
                            <CopyToClipboard text={payloadContent ?? ""} onCopy={() => setCopied(true)}>
                                <Button
                                    size="small"
                                    beforeSlot={<CopyPaste />}
                                    disabled={payloadLoading || !payloadContent}
                                >
                                    Copy to clipboard
                                </Button>
                            </CopyToClipboard>
                        </Tooltip>
                    </div>
                }
            >
                <div className="payload-modal-content">
                    {payloadLoading ? (
                        <div className="payload-spinner-container">
                            <Spinner />
                        </div>
                    ) : (
                        <pre className="payload-content">
                            {payloadContent}
                        </pre>
                    )}
                </div>
            </Modal>
        </div>
    );
}
